import React, { useEffect } from 'react'
import ComprobantesContainer from '../../components/organismos/ComprobantesContainer/ComprobantesContainer'
import {Titulo} from 'asocomponents'
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'
import FiltrosLiquidacionesContainer from '../../components/organismos/FiltrosLiquidacionesContainer/FiltrosLiquidacionesContainer'

function Comprobantes() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Comprobantes"/>
      <FiltrosLiquidacionesContainer />
      <ComprobantesContainer/>
    </Layout>
  )
}

export default Comprobantes